var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "button button-gray",
      attrs: { id: "lang-switcher" },
      on: { click: _vm.changeLanguage }
    },
    [
      _c("i", { staticClass: "fas fa-globe" }),
      _vm._v(" \n    " + _vm._s(_vm.text) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }